import type { Locale } from '@seek/melways-sites';
import { Stack, Text, TextLinkButton } from 'braid-design-system';
import { observer } from 'mobx-react';

import downloadFile from 'src/DocumentViewer/utils/downloadFile';
import { TRACKING_CANDIDATE_DETAILS } from 'src/constants/pageTrackingData';
import type { TrackStatusUpdateAttributes } from 'src/utils/eventsTypes';

import type { IAttachment } from '../../../stores/JobApplicationStore/Attachment';
import type { IAttachmentsStore } from '../../../stores/JobApplicationStore/AttachmentsStore';
import { trackDownloadDocumentEvent } from '../../../utils/events';
import Item from '../NotesAttachments/Item';

interface Props {
  attachmentsStore: IAttachmentsStore;
  locale: Locale;
  isVerifiedId: TrackStatusUpdateAttributes['isVerifiedId'];
}

const AttachmentItemList = ({
  attachmentsStore,
  locale,
  isVerifiedId,
}: Props) => (
  <Stack space="large" dividers>
    {attachmentsStore.hirerUploadedDocuments.map((attachment: IAttachment) => {
      const onClick = () => {
        downloadFile(attachment.downloadUrl, () => {
          trackDownloadDocumentEvent({
            ...attachmentsStore.jobApplication.baseTrackingAttributes,
            currentPage: TRACKING_CANDIDATE_DETAILS,
            documentType: attachment.typeName,
            attachmentId: attachment.id,
            isVerifiedId,
          });
        });
      };
      const content = (
        <Text baseline={false}>
          <TextLinkButton onClick={onClick}>
            {attachment.shortName}
          </TextLinkButton>
        </Text>
      );

      return (
        <div data-testid="attachment" key={attachment.id}>
          <Item
            type="attachment"
            user={attachment.uploadedUser || ''}
            date={attachment.uploadedDate || ''}
            isNew={attachment.isNew}
            onHide={attachment.markedAsNotNew}
            canDelete={true}
            onDelete={() => attachmentsStore.deleteAttachment(attachment.id)}
            locale={locale}
          >
            {content}
          </Item>
        </div>
      );
    })}
  </Stack>
);

export default observer(AttachmentItemList);
